/**
 * Soccer Revolution — Wishlist
 * localStorage-based, syncs all wishlist buttons on the page
 */
(function() {
  'use strict';

  var STORAGE_KEY = 'sr_wishlist';

  function escapeHTML(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // ── Storage helpers ─────────────────────────────────────────
  function load() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function save(items) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(items)); }
    catch (e) {}
  }

  function getItems() { return load(); }

  function has(id) {
    id = String(id);
    return load().some(function(i) { return String(i.id) === id; });
  }

  function add(item) {
    var list = load();
    var id = String(item.id);
    if (!list.some(function(i) { return String(i.id) === id; })) {
      list.push({
        id:    id,
        title: item.title || '',
        price: item.price || '',
        img:   item.img   || '',
        url:   item.url   || ''
      });
      save(list);
    }
    return true;
  }

  function remove(id) {
    id = String(id);
    var list = load().filter(function(i) { return String(i.id) !== id; });
    save(list);
    return true;
  }

  function toggle(item) {
    if (has(item.id)) { remove(item.id); return false; }
    else              { add(item);       return true;  }
  }

  function count() { return load().length; }

  // ── UI: update counter badges ─────────────────────────────
  function updateCounters() {
    var n = count();
    document.querySelectorAll('.sr-wish-count, .sr-wishlist-count, [data-wish-count]').forEach(function(el) {
      el.textContent = n > 0 ? n : '';
      el.classList.toggle('visible', n > 0);
    });
  }

  // ── UI: sync button states ────────────────────────────────
  function syncButtons() {
    document.querySelectorAll('[data-wish-id]').forEach(function(btn) {
      var id = String(btn.dataset.wishId);
      if (has(id)) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Quitar de favoritos');
        var label = btn.querySelector('#sr-wish-label, .sr-wish-label');
        if (label) label.textContent = 'EN FAVORITOS ✓';
        var icon = btn.querySelector('svg, #sr-wish-icon');
        if (icon) { icon.style.fill = '#e63946'; icon.style.stroke = '#e63946'; }
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Agregar a favoritos');
        var label2 = btn.querySelector('#sr-wish-label, .sr-wish-label');
        if (label2) label2.textContent = 'AGREGAR A FAVORITOS';
        var icon2 = btn.querySelector('svg, #sr-wish-icon');
        if (icon2) { icon2.style.fill = ''; icon2.style.stroke = ''; }
      }
    });
  }

  // ── Wire up wishlist buttons ──────────────────────────────
  function wireButtons() {
    document.querySelectorAll('[data-wish-id]').forEach(function(btn) {
      if (btn.dataset.wishWired) return;
      btn.dataset.wishWired = '1';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var item = {
          id:    btn.dataset.wishId,
          title: btn.dataset.wishTitle,
          price: btn.dataset.wishPrice,
          img:   btn.dataset.wishImg,
          url:   btn.dataset.wishUrl
        };
        var added = toggle(item);
        syncButtons();
        updateCounters();
        if (typeof window.srShowToast === 'function') {
          window.srShowToast(added ? '❤️ Agregado a favoritos' : '💔 Quitado de favoritos', 'info');
        }
      });
    });
  }

  // ── Wishlist page renderer ─────────────────────────────────
  function renderWishlistPage() {
    var container = document.getElementById('sr-wishlist-page');
    if (!container) return;

    var items = load();
    if (items.length === 0) {
      container.innerHTML =
        '<div class="sr-wish-empty">' +
          '<p class="sr-wish-empty__icon">💔</p>' +
          '<h2 class="sr-wish-empty__title">Tu lista de favoritos está vacía</h2>' +
          '<p class="sr-wish-empty__sub">Agrega productos haciendo clic en el corazón ❤</p>' +
          '<a href="/collections/all" class="sr-btn sr-btn--gold sr-btn--lg">Ver camisolas</a>' +
        '</div>';
      return;
    }

    var html = '<div class="sr-wish-grid">';
    items.forEach(function(item) {
      var url   = escapeHTML(item.url);
      var title = escapeHTML(item.title);
      var img   = escapeHTML(item.img || 'https://cdn.shopify.com/s/files/1/0000/0001/files/placeholder.jpg');
      var price = escapeHTML(item.price);
      var id    = escapeHTML(item.id);
      html +=
        '<div class="sr-wish-card">' +
          '<a href="' + url + '" class="sr-wish-card__img-link">' +
            '<img src="' + img + '" alt="' + title + '" class="sr-wish-card__img" loading="lazy">' +
          '</a>' +
          '<div class="sr-wish-card__body">' +
            '<a href="' + url + '" class="sr-wish-card__title">' + title + '</a>' +
            '<p class="sr-wish-card__price">' + price + '</p>' +
            '<div class="sr-wish-card__actions">' +
              '<a href="' + url + '" class="sr-btn sr-btn--black sr-btn--full">Ver producto</a>' +
              '<button class="sr-wish-card__remove" data-remove-id="' + id + '" aria-label="Quitar de favoritos" title="Quitar">' +
                '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 01-2 2H8a2 2 0 01-2-2L5 6"/><path d="M10 11v6M14 11v6"/><path d="M9 6V4h6v2"/></svg>' +
              '</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });
    html += '</div>';
    container.innerHTML = html;

    container.querySelectorAll('[data-remove-id]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        remove(btn.dataset.removeId);
        renderWishlistPage();
        updateCounters();
      });
    });
  }

  // ── Init ──────────────────────────────────────────────────
  function init() {
    wireButtons();
    syncButtons();
    updateCounters();
    renderWishlistPage();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-wire on dynamic content (e.g. cart drawer injects cards)
  // Disconnect before sync so label.textContent changes don't re-trigger the observer
  (function() {
    var pending = false;
    var mutObs = new MutationObserver(function() {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function() {
        mutObs.disconnect();
        wireButtons();
        syncButtons();
        pending = false;
        mutObs.observe(document.body, { childList: true, subtree: true });
      });
    });
    mutObs.observe(document.body, { childList: true, subtree: true });
  })();

  // Public API
  window.srWishlist = {
    add: add,
    remove: remove,
    toggle: toggle,
    has: has,
    getItems: getItems,
    count: count,
    sync: function() { syncButtons(); updateCounters(); }
  };

})();
